<div class="icon">
	<img [src]="icon" alt="" />
</div>
<div>
	<span class="displayTitle">{{ displayTitle }}</span>
	<br />
	<a [href]="link" target="_blank">
		<span class="linkTitle">{{ linkTitle }}</span>
	</a>
</div>
